/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
    AssetsMelcoModelsSupplierProduct,
    AssetsMelcoModelsSupplierProductFromJSON,
    AssetsMelcoModelsSupplierProductFromJSONTyped,
    AssetsMelcoModelsSupplierProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct
 */
export interface AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct {
    /**
     * 
     * @type {Array<AssetsMelcoModelsSupplierProduct>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct
     */
    list: Array<AssetsMelcoModelsSupplierProduct>;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct
     */
    total: number;
}

export function AssetsMelcoModelsGenericList1MelcoModelsSupplierProductFromJSON(json: any): AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct {
    return AssetsMelcoModelsGenericList1MelcoModelsSupplierProductFromJSONTyped(json, false);
}

export function AssetsMelcoModelsGenericList1MelcoModelsSupplierProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AssetsMelcoModelsSupplierProductFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function AssetsMelcoModelsGenericList1MelcoModelsSupplierProductToJSON(value?: AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AssetsMelcoModelsSupplierProductToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


